export const designationTypeLabels = {
    1: "Both Store and Market Insights",
    2: "Market Insights",
    3: "Store Insights"
}